import { createRequest } from 'mk-biz-pc'
import { Config } from './config'

const adminApi = createRequest('admin')

/**
 * 获取公共key
 */
export const getKey = () => adminApi(Config.getAuthKey)

/**
 * 用户登录
 * @param account
 * @param password
 * @param randomCode
 * @param captchaKey
 * @param captcha
 * @returns
 */
export const login = (account: string, password: string, randomCode: string, captchaKey: string, captcha: string) => {
  return adminApi(Config.userLogin, {
    data: { account, password, randomCode, captchaKey, captcha },
    cancelGlobalMsg: true
  })
}

/**
 * 用户修改密码
 * @param oldPassword
 * @param newPassword
 * @returns
 */
export const updatePassword = (oldPassword: string, newPassword: string) => {
  return adminApi(Config.updatePassword, {
    data: {
      oldPassword,
      newPassword
    },
    cancelGlobalMsg: true
  })
}

/**
 * 获取图形验证码
 * @returns
 */
export const getImageCaptcha = () => adminApi(Config.getImageCaptcha)

/**
 * 退出
 * @returns
 */
export const logout = () => adminApi(Config.userLogout)

/**
 * 获取用户应用
 */
export const getApps = () => adminApi(Config.getApps)

/**
 * 获取用户导航
 */
export const getUserGrant = () => adminApi(Config.getUserGrant)

/**
 * 获取用户信息
 * @returns
 */
export const getUser = () => adminApi(Config.getUser)
